import { endOfWeek, startOfWeek, isSameWeek } from 'date-fns';
export const getWeekDatesRange = (date, firstDayOfWeek = 1) => {
    const startOfTheWeek = startOfWeek(date, { weekStartsOn: firstDayOfWeek });
    const endOfTheWeek = endOfWeek(date, { weekStartsOn: firstDayOfWeek });
    return { startOfWeek: startOfTheWeek, endOfWeek: endOfTheWeek };
};
export const areDatesInTheSameWeek = (firstDate, secondDate, firstDayOfWeek = 1) => {
    return isSameWeek(firstDate, secondDate, { weekStartsOn: firstDayOfWeek });
};
//# sourceMappingURL=dateUtils.js.map